import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ChangePasswordComponent } from './login/change-password/change-password.component';
import { LoginService } from './login/login.service';
import { User } from './login/user';
import { BaselineSurveyService } from './modules/baseline-survey/baseline-survey.service';
import { ConfirmationDialogService } from './modules/shared/confirmation-dialog/confirmation-dialog.service';
import { ValidationService } from './modules/shared/services/validation.service';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'bhp-web';
  fullscreenData: boolean;
  user: User;
  baseURL = environment.apiUrl;
  cureentUrl: any;
  isDonorView: Boolean = false;

  constructor(public validationService: ValidationService, private accountService: LoginService,
    private router: Router,
    private confirmationDialogService: ConfirmationDialogService, private baselineService: BaselineSurveyService,
    public dialog: MatDialog,
  ) {
    this.accountService.user.subscribe((x) => { this.user = x; });

    this.isDonorView = this.isDonorViewRole();

    router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.cureentUrl = event.url;

        console.log(this.cureentUrl);
        
      }
    });

  }

  fullscreenMethod(data) {
    this.fullscreenData = data;
    this.validationService.val = this.fullscreenData;
  }

  openChangePassword() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '500px',
      height: '450px',
      data: {
        userId: this.user.responseObject.userdetailDTO.userId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  logout() {
    this.confirmationDialogService.confirm('', 'Are you sure you want to log out ?')
      .then(() => {
        this.accountService.logout();
        this.baselineService.timeToTentativeEndDate = '';
      }
      )
      .catch(() => '');
  }

  onLogoutDonor(logoutClicked: boolean) {
    if (logoutClicked) {
      this.logout();
    }
  }

  isDonorViewRole(): boolean {
    const role = this.user?.responseObject?.RoledetailDTO?.roleShortName;
    return ['KMB'].includes(role);
  }

}
